import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";
import {SubjectActionTypes} from "../../../AppLocals/Course";
import {IoCopyOutline} from "react-icons/io5";
import {BsCalendarCheck} from "react-icons/bs";
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";

export const renderSubject = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    return (
        <div key={index} style={{ fontSize: 14 }} className="p-4 flex flex-col custom-item-render relative list-item">
            <h2
                onClick={() => {
                    handleAction(SubjectActionTypes.SUBJECT_READ, item)
                }}
                className="font-bold text-base text-gray-800 tracking-wide hover:text-primary cursor-pointer">
                {item?.title}
            </h2>
            <div className="mt-1.5 flex flex-wrap items-center gap-2 leading-none">
                {renderIf(
                    item?.subject_idcode,
                    <span
                        onClick={() => {
                            copyToClipboard(item?.subject_idcode)
                            message.success(t('copied'))
                        }}
                        className="inline-flex items-center gap-1 px-2 py-1 bg-secondary-50 border border-secondary-200 rounded-full text-sm font-mono font-semibold text-secondary hover:text-secondary-600 tracking-wider cursor-pointer leading-none">
                        {item?.subject_idcode}
                        <IoCopyOutline size={12}/>
                    </span>
                )}
                {renderIf(
                    item?.number_of_sessions > 0,
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-slate-50 border border-slate-200 rounded-full text-sm font-medium text-slate-500 tracking-wide leading-none">
                        <BsCalendarCheck size={12}/>
                        {`${item?.number_of_sessions} ${t('sessions')}`}
                    </span>
                )}
                {renderIf(
                    item?.course_class_count > 0,
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-slate-50 border border-slate-200 rounded-full text-sm font-medium text-slate-500 tracking-wide leading-none">
                        <ClassroomSvg size={12}/>
                        {t('classes used', {count: item?.course_class_count})}
                    </span>
                )}
            </div>

            <div className="my-2 border-b border-color-50"/>
            {renderIf(
                item?.description,
                <div className="mt-3 text-color-300 tracking-wider max-lines-3">
                    {item?.description}
                </div>
            )}
            <div className="absolute right-5 top-5 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}
